import { addAlpha, colors, StyledIcon } from 'fitify-ui'
import { ButtonStyles } from 'fitify-ui-landing/src/components/Button/Button.Styles'
import { NAVIGATION_HEIGHT } from 'fitify-ui-landing/src/components/Navigation/Navigation.Styled'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import {
  biggerPhoneLandscape,
  biggerPhoneUp,
  phone,
} from 'fitify-ui-landing/src/theme/breakpoints'
import { zIndexes } from 'fitify-ui-landing/src/theme/zIndexes'
import styled, { css } from 'styled-components'

import { StyledContainer } from '../../Container/Container.Styled'

export const StyledHeader = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);

  ${phone(css`
    height: calc(100% - 260px);
    flex-direction: column-reverse;
  `)};
`
export const StyledHeaderContainer = styled(StyledContainer)`
  position: relative;
  display: flex;
  height: 100%;
  align-items: start;
  justify-content: space-between;
`

export const StyledHeaderDesktop = styled(StyledHeader)`
  display: flex;

  ${phone(css`
    display: none;
  `)};
`

export const StyledHeaderMobile = styled(StyledHeader)`
  display: none;

  ${phone(css`
    display: flex;
  `)};
`

export const StyledHeaderWrapper = styled.div`
  z-index: 15;
  display: flex;
  width: 100%;
  max-width: 496px;
  height: 100%;
  align-items: center;

  ${biggerPhoneLandscape(css`
    margin-top: 50px;
  `)};

  ${phone(css`
    justify-content: center;
    margin-top: 0;
  `)};

  div {
    ${phone(css`
      &:first-child {
        width: inherit;
      }
    `)};
  }

  ${TextStyles} {
    &:not(:first-child) {
      max-width: 420px;
      margin-top: 16px;
      margin-bottom: 32px;
      ${biggerPhoneLandscape(css`
        max-width: 350px;
        margin-top: 16px;
        margin-bottom: 24px;
      `)};
      ${phone(css`
        max-width: 350px;
        margin-top: 0;
        margin-bottom: 24px;
      `)};
    }

    &:nth-child(2) {
      ${phone(css`
        max-width: 600px;
        margin-bottom: 24px;
      `)};
    }

    &:nth-child(3) {
      ${phone(css`
        color: ${colors.Gray800};
      `)};
    }

    ${phone(css`
      max-width: 100%;
    `)};
  }

  ${ButtonStyles} {
    width: 100%;
    justify-content: center;
    order: 5;

    ${biggerPhoneUp(css`
      width: fit-content;
      justify-content: flex-start;
      order: 0;
    `)};
  }
`

export const StyledHeaderWrapperContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  ${ButtonStyles} {
    height: 56px;
    padding: 17px 32px;
    > span {
      font-size: 20px;
    }

    ${biggerPhoneLandscape(css`
      height: 48px;
      padding: 14.5px 28px;

      > span {
        font-size: 16px;
      }
    `)};

    ${phone(css`
      height: 48px;
      padding: 14.5px 0;

      > span {
        font-size: 16px;
      }
    `)};
  }
`

export const StyledBadgeWrapper = styled.div`
  display: flex;
  gap: 8px;

  ${StyledIcon} {
    width: auto;
    height: 40px;
  }
`

export const StyledMobileImage = styled.div`
  position: relative;
  width: calc(100% + 48px) !important;
  padding-bottom: calc(50% + 24px) !important;
  margin-right: -24px;
  margin-bottom: 24px;
  margin-left: -24px;
`

export const StyledHeaderBackground = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  overflow: hidden;
  width: 100%;
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);
  justify-content: center;
  transform: translate(-50%, -50%);

  ${phone(css`
    position: relative;
    display: inline-block;
    width: auto;
    height: auto;
  `)};

  ${biggerPhoneUp(css`
    min-height: 625px;

    ${biggerPhoneLandscape(css`
      min-height: 400px;
    `)};
  `)};
`
export const StyledImg = styled.img``
export const StyledHeaderBackgroundGradient = styled.div`
  position: absolute;
  z-index: ${zIndexes.backgroundGradient};
  top: 0;
  left: 0;
  overflow: hidden;
  width: 42%;
  height: calc(100vh - ${NAVIGATION_HEIGHT}px);
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0) 100%
  );

  opacity: 0.85;

  ${phone(css`
    display: none;
  `)};

  ${biggerPhoneUp(css`
    min-height: 625px;
  `)};
`

export const StyledScrollDiv = styled.div`
  position: relative;
  z-index: 100;
  display: flex;
  align-self: flex-end;
  margin-bottom: 80px;

  ${phone(css`
    position: absolute;
    right: 16px;
    bottom: 16px;
    margin-bottom: 0;
  `)};
`

export const StyledScrollLink = styled.div`
  width: 56px;
  height: 56px;
  padding: 16px;
  border-radius: 100px;
  backdrop-filter: blur(12px);
  background: ${addAlpha(colors.Mantis400, 0.72)};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: ${addAlpha(colors.Mantis500, 0.72)};
    opacity: 1;
  }

  ${phone(css`
    width: 48px;
    height: 48px;
    padding: 12px 14px;
    margin: 0;

    ${StyledIcon} {
      width: 21px;
      height: 26px;
    }
  `)};
`
